import { createContext, useContext, useEffect, useState } from 'react';

// إنشاء Context خاص بالسلة (Cart)
const CartContext = createContext();

export function CartProvider({ children }) {
  // تعريف حالة لتخزين عناصر السلة، وقراءتها من localStorage عند بدء التشغيل
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem('cart'); // جلب البيانات المخزنة في المتصفح
    return savedCart ? JSON.parse(savedCart) : [];  // تحويل البيانات من نص إلى مصفوفة أو إرجاع مصفوفة فارغة إذا لا توجد بيانات
  });

  // حفظ بيانات السلة في localStorage عند أي تغيير في cartItems
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems)); // تخزين البيانات كنص
  }, [cartItems]);

  // دالة لإضافة منتج إلى السلة
  const addToCart = (product) => {
    setCartItems(prevItems => {
      // التحقق إذا المنتج موجود بالفعل في السلة
      const existing = prevItems.find(item => item.id === product.id);
      if (existing) {
        // إذا موجود، زيادة الكمية بمقدار 1
        return prevItems.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        // إذا غير موجود، إضافته مع كمية 1
        return [...prevItems, { ...product, quantity: 1 }];
      }
    });
  };

  // دالة لزيادة كمية منتج معين في السلة
  const increaseQuantity = (id) => {
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // دالة لتقليل كمية منتج معين في السلة
  const decreaseQuantity = (id) => {
    setCartItems(prevItems =>
      prevItems
        .map(item =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        )
        // إزالة المنتج إذا وصلت الكمية إلى صفر
        .filter(item => item.quantity > 0)
    );
  };

  // دالة لحذف منتج بالكامل من السلة
  const removeFromCart = (id) => {
    setCartItems(prevItems => prevItems.filter(item => item.id !== id));
  };

  // حساب السعر الإجمالي لكل المنتجات في السلة (الكمية × السعر لكل منتج)
  const totalPrice = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    // توفير البيانات والدوال الخاصة بالسلة لجميع مكونات التطبيق التي تستخدم هذا الكونتكست
    <CartContext.Provider value={{
      cartItems,
      addToCart,
      increaseQuantity,
      decreaseQuantity,
      removeFromCart, // دالة حذف المنتج مضافة في الـ context
      totalPrice
    }}>
      {children}
    </CartContext.Provider>
  );
}

// هوك مخصص لاستخدام السلة داخل المكونات بشكل أسهل
export const useCart = () => useContext(CartContext);
